export default {"src":"/_next/static/media/429.2dfa9480.svg","height":377,"width":634,"blurWidth":0,"blurHeight":0};